<template>
  <v-app>
    <app-toolbar 
      v-if="user" 
      v-scroll="onScroll"/>

    <app-drawer v-if="user" />

    <app-jumbotron v-if="user" />

    <v-progress-linear 
      v-if="loading" 
      :indeterminate="loading"/>

    <app-view />

    <app-footer v-if="user" />

    <v-snackbar
      :top="snackbarProps.y === 'top'"
      :bottom="snackbarProps.y === 'bottom'"
      :right="snackbarProps.x === 'right'"
      :left="snackbarProps.x === 'left'"
      :timeout="snackbarProps.timeout"
      :color="snackbarProps.color"
      :multi-line="snackbarProps.mode === 'multi-line'"
      :vertical="snackbarProps.mode === 'vertical'"
      v-model="snackbar"
    >
      {{ snackbarProps.text }}
      <v-btn 
        dark 
        icon 
        flat 
        @click.native="snackbar = false"><v-icon>close</v-icon></v-btn>

    </v-snackbar>

    <v-fade-transition 
      mode="out-in">
      <v-btn
        v-show="isScrolling"
        fixed
        dark
        fab
        bottom
        right
        color="secondary"
        @click="$vuetify.goTo(0)"
      >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-fade-transition>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      isScrolling: false
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
    snackbarProps() {
      return this.$store.getters.snackbarProps;
    },
    snackbar: {
      get: function() {
        return this.$store.getters.showSnackbar;
      },
      set: function() {
        this.$store.dispatch("closeNotification");
      }
    }
  },
  methods: {
    logout() {
      this.$store.state.auth().signOut();
      this.$router.push("/login");
    },
    onScroll() {
      this.isScrolling =
        (window.pageYOffset || document.documentElement.scrollTop || 0) > 10;
    }
  }
};
</script>

<style>
/*.image {
  border-radius: 4px;
  width: 100%;
}
.image-style-side img {
  border-radius: 4px;
  width: 50%;
}*/
figure {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 40px;
  margin-inline-end: 40px;
  max-width: 100%;
  overflow: hidden;
}

.image > img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}
.image-style-side {
  float: right;
  margin-left: var(--ck-image-style-spacing);
}
.image-style-side {
  max-width: 50%;
}
.image {
  position: relative;
  overflow: hidden;
}
.ck-content .image {
  clear: both;
  text-align: center;
  margin: 1em 0;
}
.image > figcaption {
  color: #333;
  background-color: #f7f7f7;
  padding: 0.6em;
  font-size: 0.75em;
  outline-offset: -1px;
}
.image {
  clear: both;
  text-align: center;
  margin: 1em 0;
}
</style>
